import react, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridColDef, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, GridValueGetterParams, } from "@mui/x-data-grid";
import styled from "styled-components";
import Drawer from "../../components/common/drawer/drawer";
import { Typography, Button, Checkbox, Fab, Paper, IconButton, Stack, Tab, Tabs, CircularProgress, Dialog, DialogActions, DialogContent, TextField, DialogTitle, MenuItem, Select, Modal, FormControl, InputLabel } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { ERROR_COLOR } from "../../constants";
import { CloseOutlined } from "@mui/icons-material";
import clearFilterImage from "../../icons/clearFilter.svg"
import searchIcon from "../../icons/searchIcon.svg"
import { Add, Save, SaveAlt } from "@mui/icons-material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CloseIcon from '@mui/icons-material/Close';
import OrderLineItemModal from "../../components/modals/orderLineItemModal";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import AddOrderModal from "../../components/modals/addOrder";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import AddOrderModalDistributor from "../../components/modals/addOrderDistributor";
import moment from "moment/moment";
import Link from '@mui/material/Link';
import { saveAs } from 'file-saver';
import ExpenseAddModal from "../../components/modals/ExpenseAddModal";
const isMobile = window.innerWidth < 900;
const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
  `
      position: relative;
      `}
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${isMobile ? "column" : "row"};
`;
const HeaderButtonsContainer = styled.div`
  ${isMobile && "margin-top:10px;"}
`;
const TableContainer = styled.div`
// height: calc(
//   100vh - ${isMobile ? "56px - 20px - 82.23px" : "132px - 28px - 49.77px"}
// );
  width: 100%;
  // border: solid 1px lightGrey;
  border-radius: 8px;
`;
const AvatarContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: 100%;
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? 'flex' : 'grid'};

  ${isMobile &&
  `
    flex-direction: column;
  `}
`;
const LoadingContainer = styled.div`
  height: calc(100% - 49px);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const TabsContainer = styled.div`
  ${isMobile &&
  `
    height: calc(100vh - 56px - 20px);
  `}
`;
const GenerateReportButton = styled(Button)`
  margin-right: 10px !important;
`;
const BulkChangePinCodeButton = styled(Button)`
  margin-right: 10px !important;
`;
const PinCodeChangeButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const FabStyle = styled(Fab)`
  && {
    z-index: 1};
  }
`;
const StyledHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;
export default function ExpenseManagement() {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [loading, setLoading] = useState(false);
  const [accessChanges, setAccessChanges] = useState([]);
  const [modal, setModal] = useState(false)
  const [modalData, setModalData] = useState()
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [rsms, setRsms] = useState([]);
  const [expenseModalData, setExpenseModalData] = useState({});
  const [openExpenseViewModal, setOpenExpenseViewModal] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [editModalData, setEditModalData] = useState(false)
  const [rowCount, setRowCount] = useState();
  const [expenseTypes, setExpenseTypes] = useState([]);
  const [expensePurposes, setExpensePurposes] = useState([]);
  const [expenseType, setExpenseType] = useState("");
  const [expenseSubType, setExpenseSubType] = useState("")
  const [expenseSubTypes, setExpenseSubTypes] = useState([])
  const [expensePurpose, setExpensePurpose] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationModel, setPaginationModel] = useState({ page: currentPage - 1, pageSize: 20 });
  const [rejectData, setRejectData] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openApproveExpenseModal, setOpenApproveExpenseModal] = useState(false);
  const [approveExpenseRowData, setApproveExpenseRowData] = useState(null);
  const [claimedAmount, setClaimedAmount] = useState("");
  const [approvedAmountValue, setApprovedAmountValue] = useState("");
  const [accessModulesData, setAccessModulesData] = useState([]);
  const [reason, setReason] = useState("")
  const [imageUrl, setImageUrl] = useState("");
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [expnsStatus, setExpnsStatus] = useState("");
  const [addExpenseModal, setAddExpenseModal] = useState(false);
  const formatDateTime = (inputDateString) => {
    const inputDate = new Date(inputDateString);
    if (isNaN(inputDate.getTime())) {
      return 'Invalid Date';
    }
    const year = inputDate.getUTCFullYear();
    const month = String(inputDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(inputDate.getUTCDate()).padStart(2, '0');
    const hours = String(inputDate.getUTCHours()).padStart(2, '0');
    const minutes = String(inputDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(inputDate.getUTCSeconds()).padStart(2, '0');
    const formattedDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDateString;
  }
  const [hasSearched, setHasSearched] = useState(false);
   const [sessions, setSessions] = useState([]); // from API
      const [selectedSession, setSelectedSession] = useState("");
      const [isDateRangeDisabled, setIsDateRangeDisabled] = useState(false);
      const [isSessionDisabled, setIsSessionDisabled] = useState(false);

        const fetchSessions = async () => {
          try {
            setLoading(true);
            const response = await window.Platform.database.getAllSessions();
            if (response?.data) {
              setSessions(response.data);
            }
          } catch (error) {
            console.error("Error fetching sessions:", error);
            window.NotificationUtils.showError("Failed to load sessions");
          } finally {
            setLoading(false);
          }
        };

        const getStartAndEndDates = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // 0-based
    const day = now.getDate();

    let start, end;

    if (day <= 15) {
      start = new Date(year, month, 1);
      end = new Date(year, month, 15);
    } else {
      start = new Date(year, month, 16);
      end = new Date(year, month + 1, 0); // last day of the month
    }

    // format as YYYY-MM-DD in local timezone
    return {
      start: start.toLocaleDateString('en-CA'),
      end: end.toLocaleDateString('en-CA'),
    };
  };
  
          useEffect(() => {
            if (!startDate && !endDate) {
              setIsSessionDisabled(false);
            }
          }, [startDate, endDate]);
        
  useEffect(() => {
    if (hasSearched) {
      fetchExpense();
    }
  }, [paginationModel.page, paginationModel.pageSize]);

  useEffect(() => {
    const { start, end } = getStartAndEndDates();

    setStartDate(start);
      setEndDate(end);
     fetchAccessModules();
          fetchSessions();
    getExpenseSubtypes();
    getExpenseType();
    getExpensePurpose();
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers()
    }
    if (userData?.role == 'rsm') {
      getUsers('rsm', userData?.id)
    }
    if (userData?.role == 'asm') {
      getUsers('asm', userData?.id)
    }
  }, [])

  const getExpenseType = async () => {
    setLoading(true);
    let results = await window.Platform.database.getExpenseType();
    if (results?.status) {
      window.NotificationUtils.showError("No Data Found");
      setLoading(false);
    }
    else {
      setExpenseTypes(results.data)
      setLoading(false);
    }

  }

  const getExpenseSubtypes = async () => {
    setLoading(true);
    let results = await window.Platform.database.getExpenseSubType();
    if (results?.status) {
      window.NotificationUtils.showError("No Data Found");
      setLoading(false);
    }
    else {
      setExpenseSubTypes(results.data)
      setLoading(false);
    }

  }


  const getExpensePurpose = async () => {
    setLoading(true);
    let results = await window.Platform.database.getExpensePurpose();
    if (results?.status) {
      window.NotificationUtils.showError(results.message);
      setLoading(false);
    }
    else {
      setExpensePurposes(results.data)
      setLoading(false);
    }
  }

  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees();
    if (results?.status) {
      window.NotificationUtils.showError(results.message);
      setLoading(false);
      return;
    }
    else {
      setAllUsers(results?.data)
      setRsms(results?.data?.filter((ele) => ele?.role?.toLowerCase() == 'rsm'))
      setRms(results?.data?.filter((ele) => ele?.role?.toLowerCase() == 'se'))
      setAsms(results?.data?.filter((ele) => ele?.role?.toLowerCase() == 'asm'))
      setLoading(false);
    }
  }

  async function getUsers(role, id) {
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setAsms(results?.data)
        setRms(results?.data1)
      }
      if (role == 'asm') {
        setRms(results?.data)
      }
    } else {
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers?.filter((ele) => ele?.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele?.role == 'asm'))
      }
      if (role == 'asm') {
        setRm("")
        setRms(allUsers?.filter((ele) => ele?.role == 'se'))
      }
    }
  }

  const fetchExpense = async (filterVal = null) => {
    setLoading(true);
    try {
      let payload = {
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        startDate: startDate,
        endDate: endDate,
        filterVal: filterVal,
        ownerName: rm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        expenseSubType: expenseSubType,
        expenseType: expenseType,
        expensePurpose: expensePurpose,
        status: expnsStatus
      }
      let results = await window.Platform.database.fetchExpense(payload);
      if (results.status) {
        window.NotificationUtils.showError(results.message);
        setLoading(false);
      }
      else {
        const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        setRowCount(results?.data1)
        setAccessChanges(jsonArrayWithId);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
      setLoading(false);
    }
    finally {
      setLoading(false)
    }
  }

  
         const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId : userData?.id,
                moduleId : "hbLH083v3O"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }


  const clearFilters = async () => {
    setLoading(true);
    setExpenseSubType("")
    setEndDate("")
    setRm("")
    setRsm("")
    setAsm("")
    setExpenseType("")
    setExpensePurpose("")
    setExpnsStatus("");
    // setIsDateRangeDisabled(false);
    // setIsSessionDisabled(false);
    setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
    setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
    setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
    setPaginationModel((prev) => ({ ...prev, pageSize: 20 }))
     setAccessChanges([]);
    setRowCount(0);
    setSelectedSession("");
        const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // 0-based
    const day = now.getDate();

    let start, end;

    if (day <= 15) {
      start = new Date(year, month, 1);
      end = new Date(year, month, 15);
    } else {
      start = new Date(year, month, 16);
      end = new Date(year, month + 1, 0); // last day of the month
    }
      setStartDate(start.toLocaleDateString('en-CA'))
      setEndDate(end.toLocaleDateString('en-CA'))
    setLoading(false);
    // try {
    //   let data1 = {
    //     pageNumber: 0,
    //     recordPerPage: 20,
    //     ownerName: "",
    //     status: 0
    //   }
    //   let results = await window.Platform.database.fetchExpense(data1);
    //   const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
    //   setRowCount(results?.data1)
    //   setAccessChanges(jsonArrayWithId);
    // } catch (error) {
    //   console.error(error);
    //   window.NotificationUtils.showError("Error Fetching Data");
    //   setLoading(false);
    // }
    // finally {
    //   setLoading(false)
    // }
  }

  const showImages = (pictures) => {
    const url = window.Platform.database.funcForBaseURL() + "/file" + pictures;
    setImageUrl(url);
    setImageModalOpen(true);
  }

  const exportExpense = async () => {
    setLoading(true);
    try {
      let data = {
        startDate: startDate,
        endDate: endDate,
        ownerName: rm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
      }
      let result = await window.Platform.database.exportData("routeplan/downloadExpenseExcel",
        data
      )
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "ExpenseReport.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }

  const handleShowImage = (imgUrl) => {
    const url = window.Platform.database.funcForBaseURL() + "/file/" + imgUrl;
    setSelectedImage(url);
    setOpenImageModal(true);
  };

  const handleReject = (data) => {
    setRejectData(data);
    setOpenDialog(true);
  };

  const handleConfirmReject = async () => {
    if (reason.trim() === "") {
      window.NotificationUtils.showError("Remark is required to reject the order.")
      return;
    }
    // approveRejectExpense({ ...rejectData, reason });
    try {
      let payload = {
        approvalStatus: "2",
        id: rejectData?.data?.expenseId,
        reason: reason?.trim()
      }
      // console.log(rejectData, "payload", payload);
      // setLoading(false);
      // return;
      const results = await window.Platform.database.updateExpenseApproval(payload)
    } catch (error) {

    }
    setOpenDialog(false);
    setReason("");
    setRejectData(null);
    fetchExpense();
  };

  // Only open approve modal for approve, not for reject
  const approveRejectExpense = (val) => {
    if (val.status === "1") { // Approve
      const data = val.data || {};
      setApproveExpenseRowData(data);
      setClaimedAmount(data.Amount || "");
      setApprovedAmountValue(data.Amount || "");
      setReason("");
      setOpenApproveExpenseModal(true);
    } else {
      // Reject: run as usual
      setRejectData(val);
      setOpenDialog(true);
    }
  };

  // Handle actual approval action
  const handleApproveExpense = async () => {
    if (!approvedAmountValue || isNaN(Number(approvedAmountValue))) {
      window.NotificationUtils.showError("Please enter a valid approved amount.");
      return;
    }
    if (Number(approvedAmountValue) > Number(claimedAmount)) {
      window.NotificationUtils.showError("Approved amount cannot be greater than claimed amount.");
      return;
    }
    if (!reason || reason.trim() === "") {
      window.NotificationUtils.showError("Remark is required to approve the expense.");
      return;
    }
    setLoading(true);
    try {
      let payload = {
        approvalStatus: "1",
        id: approveExpenseRowData?.expenseId,
        claimedAmount: claimedAmount,
        userId: approveExpenseRowData?.userId,
        approvedAmount: approvedAmountValue,
        reason: reason?.trim(),
      };
      // console.log(payload, "payload for approval");
      // return;
      const results = await window.Platform.database.updateExpenseApproval(payload);
      if (results.status) {
        window.NotificationUtils.showError(results?.message);
      } else {
        window.NotificationUtils.showSuccess(results?.message);
        setOpenApproveExpenseModal(false);
        fetchExpense();
      }
    } catch (err) {
      console.log(err);
      window.NotificationUtils.showError("Something Went Wrong!");
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    setLoading(true);
    try {
      const response = await fetch(selectedImage);
      const blob = await response.blob();
      saveAs(blob, "downloaded_image.jpg");
    } catch (e) {
      window.NotificationUtils?.showError?.("Download failed");
    }
    setLoading(false);
  };

  const handleOpenExpenseModal = (data) => {
    setExpenseModalData(data)
    setOpenExpenseViewModal(true)
  }


  const handleCloseExpenseViewModal = () => {
    setOpenExpenseViewModal(false);
    setExpenseModalData({})
  };

  // const formatTimeStamp = (timestampFromDB) => {
  //   const options = {
  //     timeZone: 'Asia/Kolkata',
  //     year: 'numeric',
  //     month: 'long',
  //     day: 'numeric',
  //     hour: 'numeric',
  //     minute: 'numeric',
  //     hour12: true,  // Use 12-hour clock
  //   };
  //   const formattedDate = new Date(timestampFromDB).toLocaleString('en-US', options);

  //   return formattedDate;
  // };

  const formatTimeStamp = (timestampFromDB) => {
    if (!timestampFromDB) return null;
    const date = new Date(timestampFromDB);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getEmployeeColumns = () => {
    let result = [
      {
        field: "name",
        headerName: "Name",
        width: 150,
        // height: 10,
        // headerAlign: 'center',
        sortable: false,
        filterable: false,
        // editable: true,
        renderCell: (params) => {
          let name = params.row.name || "";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "partyId1",
        headerName: "Party Id",
        width: 130,
        // height: 10,
        // headerAlign: 'center',
        sortable: false,
        filterable: false,
        // editable: true,
        renderCell: (params) => {
          let name = params.row.partyId || "";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "party",
        headerName: "Party Name",
        width: 200,
        // height: 10,
        // headerAlign: 'center',
        sortable: false,
        filterable: false,
        // editable: true,
        renderCell: (params) => {
          let name = params.row.schoolName || params.row.DistributorName || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "createdAtDateEx",
        headerName: "Submission Date",
        width: 160,
        sortable: false,
        filterable: false,
        // editable: true,
        renderCell: (params) => {
          let dateStr = params.row.createdAt;
          let name = "N/A";
          if (dateStr) {
            const dateObj = new Date(dateStr);
            name = dateObj.toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              // hour: "2-digit",
              // minute: "2-digit",
              // second: "2-digit",
              // hour12: true,
            });
          }
          // let name = params.row.createdAt || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "createdAtDate",
        headerName: "Expense Date",
        width: 160,
        sortable: false,
        filterable: false,
        // editable: true,
        renderCell: (params) => {
          let dateStr = params.row.date;
          let name = "N/A";
          if (dateStr) {
            const dateObj = new Date(dateStr);
            name = dateObj.toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              // hour: "2-digit",
              // minute: "2-digit",
              // second: "2-digit",
              // hour12: true,
            });
          }
          // let name = params.row.createdAt || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "TYPE",
        headerName: "Expense Type",
        width: 140,
        filterable: true,
        // height: 10,
        // headerAlign: 'center',
        sortable: false,
        // editable: true,
        valueGetter: (params) => {
          return (params?.row?.expenseTypeName || "N/A");
        },
        renderCell: (params) => {
          let name = params.row?.expenseTypeName || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Amount",
        headerName: "Claimed Amount",
        width: 170,
        filterable: true,
        // height: 10,
        // headerAlign: 'center',
        sortable: false,
        // editable: true,
        valueGetter: (params) => {
          return (params?.row?.Amount || "N/A");
        },
        renderCell: (params) => {
          let name = Number(params.row.Amount)?.toFixed(2) || "N/A"
          // let name1 = name?.toFixed(2)
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Amount11",
        headerName: "Approved Amount",
        width: 160,
        filterable: true,
        // height: 10,
        // headerAlign: 'center',
        sortable: false,
        // editable: true,
        valueGetter: (params) => {
          return (params?.row?.approvedAmount || "N/A");
        },
        renderCell: (params) => {
          let name = Number(params.row.approvedAmount)?.toFixed(2) || "N/A"
          // let name1 = name?.toFixed(2)
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Status",
        headerName: "Status",
        width: 90,
        filterable: true,
        // height: 10,
        // headerAlign: 'center',
        sortable: false,
        // editable: true,
        valueGetter: (params) => {
          return params?.row?.Status == "1" ? "Approved" : params?.row?.Status == "2" ? "Rejected" : "Pending" || "N/A"
        },
        renderCell: (params) => {
          let name = params?.row?.Status == "1" ? "Approved" : params?.row?.Status == "2" ? "Rejected" : "Pending" || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "View",
        headerName: "View",
        minWidth: 100,
        filterable: false,
        sortable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleOpenExpenseModal(params.row)}
                    sx={{ minWidth: "80px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={openExpenseViewModal} onClose={handleCloseExpenseViewModal}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: 900,
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" component="h2" style={{ textAlign: "center" }} sx={{ color: "black", fontSize: "16px", fontWeight: "600" }}>
                    Expense Details
                  </Typography>
                  <IconButton onClick={() => setOpenExpenseViewModal(false)} style={{ position: "absolute", top: 10, right: 10 }}>
                    <CloseOutlined />
                  </IconButton>
                  {/* <hr style={{ width: "100%", color:"black", fontWeight:"800" }} /> */}
                  <hr style={{ width: "100%", border: "none", borderTop: "2px solid #222", margin: "16px 0" }} />
                  <div>
                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Name : </b> <span style={{ color: "black", fontWeight: "500" }}> {expenseModalData?.name || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Approved By : </b> <span style={{ color: "black", fontWeight: "500" }}> {expenseModalData?.approvedByUser || "N/A"}</span>
                      </div>
                    </div>

                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Party ID : </b> <span style={{ color: "black", fontWeight: "500" }}> {expenseModalData?.partyId || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Party Name : </b> <span style={{ color: "black", fontWeight: "500" }}> {expenseModalData?.schoolName || expenseModalData?.DistributorName || "N/A"}</span>
                      </div>
                    </div>

                    {/* <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{color:"black", fontSize:"15px"}}> Status : </b> <span style={{color:"black", fontWeight:"500"}}> {expenseModalData?.Status == "1" ? "Approved" : expenseModalData?.Status == "2" ? "Rejected" : "Pending" || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{color:"black", fontSize:"15px"}}> Approved By : </b><span style={{color:"black", fontWeight:"500"}}>  {expenseModalData?.approvedByUser || "N/A"}</span>
                      </div>
                    </div> */}

                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}>Claimed Amount : </b>
                        <span style={{ color: "black", fontWeight: "500" }}>  {expenseModalData?.Amount || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}>Approved Amount : </b>
                        <span style={{ color: "black", fontWeight: "500" }}>  {expenseModalData?.approvedAmount || "N/A"}</span>
                      </div>

                    </div>

                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Date : </b>
                        <span style={{ color: "black", fontWeight: "500" }}> {formatTimeStamp(expenseModalData?.date) || 'N/A'}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Expense Type : </b><span style={{ color: "black", fontWeight: "500" }}>  {expenseModalData?.expenseTypeName || "N/A"}</span>
                      </div>

                    </div>
                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Expense Purpose : </b> <span style={{ color: "black", fontWeight: "500" }}> {expenseModalData?.expensePurposeName || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Remark : </b><span style={{ color: "black", fontWeight: "500" }}>  {expenseModalData?.remarks || "N/A"}</span>
                      </div>

                    </div>
                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Status : </b><span style={{ color: "black", fontWeight: "500" }}>  {expenseModalData?.Status == 0 ? "Pending" : expenseModalData?.Status == 1 ? "Approved" : expenseModalData?.Status == 2 ? "Rejected" : "N/A" || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}>Action taken By : </b> <span style={{ color: "black", fontWeight: "500" }}>  {expenseModalData?.approvedByUser || "N/A"}</span>
                      </div>

                    </div>

                    <div className="row mb-3" style={{ alignItems: "center" }}>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}>{expenseModalData?.Status == 1 ? "Approved Remark" : expenseModalData?.Status == 2 ? "Rejected Remark" : "Remark" || "N/A"} : </b> <span style={{ color: "black", fontWeight: "500" }}> {expenseModalData?.reason || "N/A"}</span>
                      </div>
                      <div className="col-md-6" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <b style={{ color: "black", fontSize: "15px" }} >Attachment</b>
                        <IconButton
                          variant="extended"
                          disabled={!expenseModalData?.BillLink}
                          color="primary"
                          onClick={e => {
                            e.stopPropagation();
                            handleShowImage(expenseModalData?.BillLink);
                          }}
                          sx={{ ml: 1 }}
                        >
                          <Button className="primary" variant="contained" size="small" disabled={!expenseModalData?.BillLink}>View</Button>
                          {/* <RemoveRedEyeIcon /> */}
                        </IconButton>
                      </div>
                    </div>

                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseExpenseViewModal} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },
     accessModulesData && accessModulesData[0]?.is_approve?.toLowerCase() != "no" &&   {
        field: "Actions",
        headerName: "Actions",
        editable: false,
        hide: true,
        minWidth: 100,
        filterable: false,
        disableExport: true,
        renderCell: (params) => {
          let value = params.row?.routeId;
          let route_line_items_id = params.row?.route_line_items_id;
          return (
            <>
              <Tooltip title="Click to approve Expense"><IconButton disabled={params.row?.Status === "1" || params.row?.Status === "2"} variant="extended" sx={{ color: "#008000" }} onClick={(e) => {
                e.stopPropagation();
                approveRejectExpense({ status: "1", data: params.row });
              }} >
                <ThumbUpIcon />
              </IconButton></Tooltip>
              <Tooltip title="Click to reject Expense"><IconButton disabled={params.row?.Status === "1" || params.row?.Status === "2"} variant="extended" sx={{ color: "red" }}
                onClick={(e) => { e.stopPropagation(); handleReject({ status: "2", data: params.row }); }}>
                <ThumbDownIcon />
              </IconButton></Tooltip>
            </>
          );
        },
      },
    ];


    return result
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer className="d-flex justify-content-end align-items-center mr-2">
        <Typography variant="body1" className="ml-4" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
        <Select
          value={paginationModel.pageSize}
          variant="outlined"
          size="small"
          onChange={(e) => { setHasSearched(true); setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
          sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}
        >
          {[10, 20, 30, 50, 100].map((role) => (
            <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role}</MenuItem>
          ))}
        </Select>
      </GridToolbarContainer>
    );
  }



  const renderContent = () => {
    return (
      <DataGridContainer style={{ height: !accessChanges?.length ? '200px' : 'auto' }}>
        <DataGrid
          className="payrollGrid"
          //   checkboxSelection={true}
          density="compact"
          rows={accessChanges}
          columns={getEmployeeColumns()}
          sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
          disableSelectionOnClick
          disableRowSelectionOnClick
          rowHeight={60}
          disableDensitySelector
          pageSizeOptions={[10]}
          onFilterModelChange={(val) => {
            fetchExpense(val)
          }
          }
          filterMode="server"
          rowCount={rowCount}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          components={{
            Toolbar: CustomToolbar,
          }}
        />
      </DataGridContainer>
    );
  }

  return (
    <>

      <StaffEditorPageContainer>
        <HeaderContainer>
          {/* <Typography variant="h5">Order Management</Typography> */}
          {loading && <OpaqueLoading />}
          <div className="container-fluid" style={{ width: "100%" }}>
            <Paper elevation={3}
              sx={{
                p: 2,
                mb: 2,
                width: '100%',        // takes full width of parent
                // maxWidth: '1000px',   // optional: control max width
                mx: 'auto',
                backgroundColor: "#ebf0fa"          // center it horizontally
              }}>
              <div className="row mb-2">
                {userData?.role.includes('admin') && <div className="col-md-3">
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                    <Select label="Select HO" value={rsm} size="small" onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setAsm(""); setRm(""); }} sx={{ width: '100%', fontSize: 14 }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>All</MenuItem>
                      {rsms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{role.name} - {role.username}</MenuItem>))}
                    </Select>
                  </FormControl>
                </div>}
                {userData?.role != 'asm' && <div className="col-md-3">
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM </InputLabel>
                    <Select label="Select ARM" value={asm} size="small" onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm("") }} sx={{ width: '100%', fontSize: 14 }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>All</MenuItem>
                      {asms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{role.name} - {role.username}</MenuItem>))}
                    </Select>
                  </FormControl>
                </div>}
                <div className="col-md-3">
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM</InputLabel>
                    <Select label="Select RM " value={rm} size="small" onChange={(e) => { setRm(e.target.value); getUsers('rm', e.target.value); }} sx={{ width: '100%', fontSize: 14 }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>All</MenuItem>
                      {rms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{role.name} - {role.username}</MenuItem>))}
                    </Select>
                  </FormControl>
                </div>
                <div className="col-md-3">
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Status</InputLabel>
                    <Select label="Select Status" value={expnsStatus} size="small" onChange={(e) => { setExpnsStatus(e.target.value); }} sx={{ width: '100%', fontSize: 14 }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }} >All</MenuItem>
                      <MenuItem key={1} value={"pending"} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>Pending</MenuItem>
                      <MenuItem key={2} value={"approved"} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>Approved</MenuItem>
                      <MenuItem key={3} value={"rejected"} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>Rejected</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-3">
                  <FormControl size="small" fullWidth>
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}> Expense Purpose </InputLabel>
                    <Select label="Expense Purpose" value={expensePurpose} size="small" onChange={(e) => { setExpensePurpose(e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>All</MenuItem>
                      {expensePurposes?.map((role) => (<MenuItem key={role} value={role.expensePurposeId} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{role.expensePurposeName}</MenuItem>))}
                    </Select>
                  </FormControl>
                </div>
                <div className="col-md-3 ">
                  <FormControl size="small" fullWidth>
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Expense Sub Type </InputLabel>
                    <Select label="Expense Sub Type" value={expenseSubType} size="small" onChange={(e) => { setExpenseSubType(e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>All</MenuItem>
                      {expenseSubTypes?.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{role.name}</MenuItem>))}
                    </Select>
                  </FormControl>
                </div>
                <div className="col-md-3">
                  <FormControl size="small" fullWidth>
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Expense Type </InputLabel>
                    <Select label="Expense Type" value={expenseType} size="small" onChange={(e) => { setExpenseType(e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>All</MenuItem>
                      {expenseTypes?.map((role) => (<MenuItem key={role} value={role.expenseTypeId} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{role.expenseTypeName}</MenuItem>))}
                    </Select>
                  </FormControl>
                </div>
               {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" &&   <div className="col-md-3">
                  <Button variant="contained" size="small" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ fontSize: '13px', borderRadius: '10px' }} onClick={() => exportExpense()}>
                    Download
                  </Button>
                </div>}
              </div>
              <div className="row mt-3">
                <div className="col-md-3">
                  <FormControl size="small" fullWidth>
                    {/* <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>From Date</InputLabel> */}
                    <TextField size="small" label="Start Date" type="date" className="form-control" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }} value={startDate} 
                    // onChange={(e) => setStartDate(e.target.value)}
                    //  disabled={isDateRangeDisabled}
                      onChange={(e) => {
                        const value = e.target.value;
                        setStartDate(value);
                        // if (value) {
                        //   setIsSessionDisabled(true);
                        //   setSelectedSession("");
                        // } else if (!value && !endDate) {
                        //   setIsSessionDisabled(false);
                        // }
                      }}
                      InputLabelProps={{
                        shrink: true,
                        style: { color: "black", fontSize: "13px", fontWeight: 500 }
                      }}
                      inputProps={{
                        style: { color: "black", fontSize: "13px", fontWeight: 500 }
                      }}
                    />
                  </FormControl>
                </div>
                <div className="col-md-3">
                  {/* <Typography variant="body1" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>To Date</Typography> */}
                  <TextField label="End Date" size="small" type="date" className="form-control" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }} value={endDate} 
                  // onChange={(e) => setEndDate(e.target.value)}
                  //  disabled={isDateRangeDisabled}
                      onChange={(e) => {
                        const value = e.target.value;
                        setEndDate(value);
                        // if (value) {
                        //   setIsSessionDisabled(true);
                        //   setSelectedSession("");
                        // } else if (!value && !startDate) {
                        //   setIsSessionDisabled(false);
                        // }
                      }}
                    InputLabelProps={{
                      shrink: true,
                      style: { color: "black", fontSize: "13px", fontWeight: 500 }
                    }}
                    inputProps={{
                      style: { color: "black", fontSize: "13px", fontWeight: 500 }
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <Button variant="contained" color="primary" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => { fetchExpense(); setHasSearched(true); }}>
                    Find
                  </Button>
                </div>
                <div className="col-md-3">
                  <Button variant="contained" color="secondary" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => clearFilters()}>
                    Clear Filters
                  </Button>
                </div>


              </div>
              <div className="row mt-2">
                <div className="col-md-3">
                                                        <FormControl fullWidth size="small">
                                                          <InputLabel
                                                            sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                          >
                                                            Select Session
                                                          </InputLabel>
                                                          <Select
                                                            label="Select Session"
                                                            value={selectedSession}
                                                            // disabled={isSessionDisabled}
                                                            sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                            onChange={(e) => {
                                                              const selected = sessions.find((item) => item.id === e.target.value);
                                                              setSelectedSession(e.target.value);
                                    
                                                              // if (selected) {
                                                                // ✅ Convert UTC → IST (local date)
                                                                const start = new Date(selected.startDate);
                                                                const end = new Date(selected.endDate);
                                    
                                                                const startIST = new Date(start.getTime() + (5.5 * 60 * 60 * 1000))
                                                                  .toISOString()
                                                                  .split("T")[0];
                                                                const endIST = new Date(end.getTime() + (5.5 * 60 * 60 * 1000))
                                                                  .toISOString()
                                                                  .split("T")[0];
                                    
                                                                setStartDate(startIST);
                                                                setEndDate(endIST);
                                    
                                                                // ✅ Disable manual date range if session chosen
                                                                // setIsDateRangeDisabled(true);
                                                              // } else {
                                                                // ✅ If cleared, re-enable date inputs
                                                                // setIsDateRangeDisabled(false);
                                                              // }
                                                            }}
                                    
                                                          >
                                                            <MenuItem value="">
                                                              <em>Select Session</em>
                                                            </MenuItem>
                                                            {sessions.map((s) => (
                                                              <MenuItem key={s.id} value={s.id}>
                                                                {s.sessionName}
                                                              </MenuItem>
                                                            ))}
                                                          </Select>
                                                        </FormControl>
                                                      </div>
              </div>

            </Paper>
           {accessModulesData && accessModulesData[0]?.is_add?.toLowerCase() != "no" &&   <Box display="flex" justifyContent="flex-end" gap={2}>
              <div className="col-md-3">
                <Button variant="contained" color="primary" className=" w-100"
                  onClick={() => setAddExpenseModal(true)} sx={{ borderRadius: '10px', fontSize: "14px" }}>
                  <Add sx={{ mr: 1 }} />
                  Add Expense
                </Button>
              </div>
            </Box>}
          </div>
        </HeaderContainer>
        <TableContainer>
          {renderContent()}
        </TableContainer>
      </StaffEditorPageContainer>
      {
        modal &&
        <OrderLineItemModal
          onCancel={() => setModal(null)}
          loading={loading}
          data={modalData}
        //   onSubmit={updateWarehouseData}
        />
      }
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>Reject Expense</DialogTitle>
        <DialogContent>
          <TextField autoFocus margin="dense" label="Remark" type="text" fullWidth variant="outlined" value={reason} onChange={(e) => setReason(e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmReject} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openApproveExpenseModal} onClose={() => setOpenApproveExpenseModal(false)} fullWidth>
        <DialogTitle>Approve Expense</DialogTitle>
        <DialogContent>
          <TextField margin="dense" label="Amount Claimed" type="text" fullWidth variant="outlined" value={claimedAmount} disabled />
          <TextField margin="dense" label="Amount Approved" type="number" fullWidth variant="outlined" value={approvedAmountValue} onChange={(e) => setApprovedAmountValue(e.target.value)} />
          <TextField margin="dense" label="Remark" type="text" fullWidth variant="outlined" value={reason} onChange={(e) => setReason(e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenApproveExpenseModal(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleApproveExpense} color="primary" disabled={loading}>
            Approve
          </Button>
        </DialogActions>
      </Dialog>

      {/* <Dialog open={openImageModal} onClose={() => setOpenImageModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Image Preview</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
            <img src={selectedImage} alt="Preview" style={{ maxWidth: 400, maxHeight: 400, borderRadius: 8 }} />
            <Button variant="contained" color="primary" onClick={() => {   saveAs(selectedImage, 'report.jpg'); }}>
              Download
            </Button>
            <IconButton aria-label="close" onClick={() => { setOpenImageModal(false) }} sx={{ position: "absolute", right: 8, top: 8, color:"black", fontWeight:"500"}} >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogContent>
      </Dialog> */}

      <Dialog open={openImageModal} onClose={() => setOpenImageModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Image Preview</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
            <img src={selectedImage} alt="Preview" style={{ maxWidth: 400, maxHeight: 400, borderRadius: 8 }} />
            <Button
              variant="contained"
              color="primary"
              onClick={handleDownload}
              startIcon={<SaveAlt />}
              disabled={loading}
            >
              Download
            </Button>
            <IconButton aria-label="close" onClick={() => { setOpenImageModal(false) }} sx={{ position: "absolute", right: 8, top: 8, color: "black", fontWeight: "500" }} >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogContent>
      </Dialog>


      {
        addExpenseModal &&
        <ExpenseAddModal
          onClose={() => setAddExpenseModal(false)}
          loading={loading}
          fetchExpense={() => fetchExpense()}
        //   onSubmit={updateWarehouseData}
        />
      }
    </>
  );
}
